// File#: _1_alert
// Usage: codyhouse.co/license

// Helper function to remove class (works with or without Util)
function removeAlertClass(element, className) {
  if (typeof Util !== 'undefined' && Util.removeClass) {
    Util.removeClass(element, className);
  } else {
    element.classList.remove(className);
  }
}

// Make initAlerts available globally so it can be called after AJAX requests
window.initAlerts = function() {
  // Initialize close buttons for all alerts
  var alertClose = document.getElementsByClassName('js-alert__close-btn');
    for( var i = 0; i < alertClose.length; i++) {
    var btn = alertClose[i];
    // Reset the data attribute to allow re-initialization
    if (btn.dataset) {
      btn.dataset.alertListenerAttached = 'false';
    }
    initAlertEvent(btn);
  }
  
  // Auto-dismiss alerts after 5 seconds
  var alerts = document.getElementsByClassName('js-alert');
  for( var i = 0; i < alerts.length; i++) {
    var alert = alerts[i];
    // Only set timeout if alert doesn't already have one
    if (!alert.dataset || !alert.dataset.autoDismissSet) {
      if (alert.dataset) {
        alert.dataset.autoDismissSet = 'true';
      }
      setTimeout(function(alertElement) {
        if (alertElement && alertElement.classList && alertElement.classList.contains('alert--is-visible')) {
          removeAlertClass(alertElement, 'alert--is-visible');
          // Remove from DOM after animation
          setTimeout(function() {
            if (alertElement && alertElement.parentNode) {
              alertElement.parentNode.removeChild(alertElement);
    }
          }, 300);
        }
      }, 5000, alert); // 5 seconds
    }
  }
};

function initAlertEvent(element) {
  // Check if already initialized to avoid duplicate listeners
  if (element.dataset && element.dataset.alertListenerAttached === 'true') {
    return;
  }
  
  // Mark as initialized
  if (element.dataset) {
    element.dataset.alertListenerAttached = 'true';
  }
  
  element.addEventListener('click', function(event){
    event.preventDefault();
    event.stopPropagation();
    var alert = element.closest('.js-alert');
    if (alert) {
      // Remove the visible class
      removeAlertClass(alert, 'alert--is-visible');
      // Remove from DOM after animation
      setTimeout(function() {
        if (alert && alert.parentNode) {
          alert.parentNode.removeChild(alert);
        }
      }, 300);
    }
  });
}

// Initialize on page load
$(document).ready(function() {
  window.initAlerts();
});